import React from 'react';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ForOwnersPage() {
  return <>
      <SEO title="Aspect for Owners" description="Enable downstream usage of property imagery with clear governance, privacy controls, and approval authority." data-id="element-265" />
      <div className="space-y-24 md:space-y-32" data-id="element-266">
        {/* Intro */}
        <section className="max-w-2xl" data-id="element-267">
          <span className="text-aspect-gray block mb-4" data-id="element-268">For Owners</span>
          <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-8 text-aspect-black" data-id="element-269">
            Enable downstream usage without sacrificing governance or privacy.
          </h1>
          <div className="mt-10" data-id="element-270">
            <Link to="/owners/submit" data-id="element-271">
              <Button variant="primary" icon data-id="element-272">
                Submit a project
              </Button>
            </Link>
          </div>
        </section>

        {/* Why Owners Participate */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-273">
          <div className="md:col-span-4" data-id="element-274">
            <span className="text-aspect-gray" data-id="element-275">Value</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-276">
            <h2 className="text-2xl font-medium" data-id="element-277">Why Owners Participate</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-278">
              <p data-id="element-279">
                Aspect allows property owners to enable professional
                documentation and controlled downstream use without losing
                authority over what is shown or how images are used.
              </p>
            </div>
          </div>
        </section>

        {/* What Owners Control */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-280">
          <div className="md:col-span-4" data-id="element-281">
            <span className="text-aspect-gray" data-id="element-282">Control</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-283">
            <h2 className="text-2xl font-medium" data-id="element-284">What Owners Control</h2>
            <ul className="space-y-2 text-aspect-black/80 max-w-xl" data-id="element-285">
              <li data-id="element-286">What is photographed</li>
              <li data-id="element-287">Review and approval before publication</li>
              <li data-id="element-288">Visibility and location specificity</li>
              <li data-id="element-289">Usage scope and restrictions</li>
              <li data-id="element-290">Takedown and removal rights</li>
            </ul>
          </div>
        </section>

        {/* Privacy */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-291">
          <div className="md:col-span-4" data-id="element-292">
            <span className="text-aspect-gray" data-id="element-293">Privacy</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-294">
            <h2 className="text-2xl font-medium" data-id="element-295">Privacy & Visibility</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-296">
              <p data-id="element-297">Owners define what level of detail is acceptable.</p>
              <p data-id="element-298">Location information can be generalized or withheld.</p>
              <p data-id="element-299">Sensitive areas or details are excluded by default.</p>
            </div>
          </div>
        </section>

        {/* Approval Authority */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-300">
          <div className="md:col-span-4" data-id="element-301">
            <span className="text-aspect-gray" data-id="element-302">Approval</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-303">
            <h2 className="text-2xl font-medium" data-id="element-304">Approval Authority</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-305">
              <p data-id="element-306">Nothing is published without owner approval.</p>
              <p data-id="element-307">Owners review images before they enter the system.</p>
            </div>
          </div>
        </section>

        {/* No Obligations */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-308">
          <div className="md:col-span-4" data-id="element-309">
            <span className="text-aspect-gray" data-id="element-310">Scope</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-311">
            <h2 className="text-2xl font-medium" data-id="element-312">
              What Owners Are Not Asked to Do
            </h2>
            <ul className="space-y-2 text-aspect-gray max-w-xl" data-id="element-313">
              <li data-id="element-314">Coordinate photography logistics</li>
              <li data-id="element-315">Manage manufacturer requests</li>
              <li data-id="element-316">Track downstream usage</li>
            </ul>
          </div>
        </section>

        {/* Participation Process */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12 pb-12" data-id="element-317">
          <div className="md:col-span-4" data-id="element-318">
            <span className="text-aspect-gray" data-id="element-319">Participation</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-320">
            <h2 className="text-2xl font-medium" data-id="element-321">Participation Process</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-322">
              <p data-id="element-323">Submit a completed property.</p>
              <p data-id="element-324">
                Aspect coordinates scope, access, and approvals before any
                photography is scheduled.
              </p>
              <div className="pt-4" data-id="element-325">
                <Link to="/owners/submit" data-id="element-326">
                  <Button variant="primary" icon data-id="element-327">
                    Submit a project
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>;
}